import type { User, UserRole } from '@backend/prisma';

import { stwFetch } from '@/utils/stwFetch';

export interface UserResult extends User {
  user_role: UserRole;
}

export interface PublicUserResult {
  id: string;
  username: string;
  created_at: Date;
  avatar: string | null;
}

/**
 * Get current authenticated user's full profile data
 */
export const getUser = async (): Promise<UserResult> => {
  try {
    const { user } = await stwFetch('GET', '/user');
    return user;
  } catch (error: any) {
    if (error.status === 401) {
      throw new Error('Email not verified');
    }
    throw error;
  }
};

/**
 * Get public user information by ID (no authentication required)
 */
export const getPublicUser = async (
  id: User['id']
): Promise<PublicUserResult> => {
  const { user } = await stwFetch('GET', `/user/${id}`);
  return user;
};
